/**
 * El orden de las tarjetas de horario.
 *
 * EasyAppointments no tiene un «puesto» del profesional: el dueño lo arregla
 * aquí, en los huecos de esta pantalla. Se recuerda por negocio; si llega
 * alguien nuevo, se pone al final. Si desaparece, su hueco se cierra.
 */

export const claveOrdenHorarios = (accountId: string) => `agendify.horarios.orden.${accountId}`

export function leerOrdenGuardado(accountId: string): number[] | null {
    try {
        const g = localStorage.getItem(claveOrdenHorarios(accountId))
        if (!g) return null
        const arr = JSON.parse(g) as unknown
        if (!Array.isArray(arr) || arr.some((x) => typeof x !== 'number')) return null
        return arr
    } catch {
        return null
    }
}

export function recordarOrden(accountId: string, orden: number[]): void {
    try {
        localStorage.setItem(claveOrdenHorarios(accountId), JSON.stringify(orden))
    } catch {
        /* modo privado */
    }
}

/** Los que siguen existiendo, en el orden guardado; los nuevos, al final. */
export function aplicarOrden(actuales: readonly number[], guardado: readonly number[] | null): number[] {
    if (!guardado || guardado.length === 0) return [...actuales]
    const vivos = new Set(actuales)
    const conocidos = guardado.filter((id) => vivos.has(id))
    const ya = new Set(conocidos)
    return [...conocidos, ...actuales.filter((id) => !ya.has(id))]
}

/** Saca a `id` y lo deja en el hueco `indice` (0 = arriba). */
export function moverAHueco(orden: readonly number[], id: number, indice: number): number[] {
    const sin = orden.filter((x) => x !== id)
    const i = Math.max(0, Math.min(Math.trunc(indice), sin.length))
    return [...sin.slice(0, i), id, ...sin.slice(i)]
}

export function subirEnOrden(orden: readonly number[], id: number): number[] {
    const i = orden.indexOf(id)
    if (i <= 0) return [...orden]
    return moverAHueco(orden, id, i - 1)
}

export function bajarEnOrden(orden: readonly number[], id: number): number[] {
    const i = orden.indexOf(id)
    if (i < 0 || i >= orden.length - 1) return [...orden]
    return moverAHueco(orden, id, i + 1)
}
